import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { fetchAccountDetails } from '../../../actions/hub/hubAccountPageActions';
import { fetchAllEnrolments } from '../../../actions/hub/hubEnrolmentsPageActions';
import withHeadTag from '../../../common/HeadComponent';
import PageError from '../../../common/PageError';
import useAccountPricingPlanQuery from '../../../hooks/queries/useAccountPricingPlanQuery';
import AccountPageLayout from '../../../templates/AccountPageLayout/AccountPageLayout';
import useScrollToAnchor from '../../../v2/common/hooks/useScrollToAnchor';
import PaymentPolicyFAQ from '../components/PaymentPolicyFAQ';
import { isLegacyPlan } from '../helpers';
import NextPaymentSection from './components/NextPaymentSection/NextPaymentSection';
import PricingPlanDetailsSection, {
  PLAN_DETAILS_SECTION_ID,
} from './components/PricingPlanDetailsSection/PricingPlanDetailsSection';

const fetchData = () => (dispatch) => {
  return dispatch(fetchAccountDetails()).then(() => {
    return dispatch(fetchAllEnrolments());
  });
};

const PricingPlanDetailsPage = () => {
  const {
    data: accountPricingPlan,
    isLoading: isLoadingAccountPricingPlan,
    isError: isErrorAccountPricingPlan,
  } = useAccountPricingPlanQuery();
  const { currentPricingPlan, upcomingPricingPlan } = accountPricingPlan || {};
  const dispatch = useDispatch();
  const isContentReady = !isLoadingAccountPricingPlan && !isErrorAccountPricingPlan;

  useScrollToAnchor(PLAN_DETAILS_SECTION_ID, isContentReady);

  useEffect(() => {
    dispatch(fetchData);
  }, [dispatch]);

  return (
    <AccountPageLayout loading={isLoadingAccountPricingPlan}>
      {!isLoadingAccountPricingPlan && isErrorAccountPricingPlan && (
        <PageError activePage="hub-page" retryEnabled={false} />
      )}
      {!isLoadingAccountPricingPlan && !isErrorAccountPricingPlan && (
        <section className="mb-6">
          <NextPaymentSection />
          <PricingPlanDetailsSection plan={upcomingPricingPlan || currentPricingPlan} />
        </section>
      )}
      {!isLegacyPlan(currentPricingPlan) && <PaymentPolicyFAQ />}
    </AccountPageLayout>
  );
};

export default withHeadTag(PricingPlanDetailsPage);
